/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- This is a utility hook and return types can be inferred for QoL */
import { SUPPORT_URL_ORGANIZER } from "@shared/constants/links/help-center";
import { AuthProfileSerializer } from "@shared/modules/auth/types";
import { useTranslation } from "@shared/utils/internationalization";
import { isPlatform } from "@shared/utils/get-platform";
import { LinksType } from "../../modules/navigation/types/navbar-types";

const useNavigationRoutes = () => {
  // We use the common namespace since this hook may contain utils for auth/non-auth scenarios
  const { t } = useTranslation("common");

  const getLoggedInNavBarLinks = (user: AuthProfileSerializer): LinksType => {
    // Electron desktop app: only show Support link (Logout is handled separately)
    if (isPlatform("desktop")) {
      return [
        {
          href: SUPPORT_URL_ORGANIZER,
          label: t("Support"),
        },
      ];
    }

    const newLoggedInLinks: LinksType = [
      {
        href: "/account/upcoming",
        label: t("Upcoming"),
      },
      {
        href: "/account/my-orders/",
        label: t("Orders"),
      },
      {
        href: "/account/waitlists",
        label: t("Waitlists"),
      },
      {
        href: "/account/memberships/",
        label: t("Memberships"),
      },
      {
        href: "/account/credits/",
        label: t("Credits"),
      },
      {
        href: "/account/products",
        label: "Products",
      },
      {
        href: "/account/saved-events/",
        label: t("Saved Events"),
      },
      {
        href: "/account/profile/personal-info/",
        label: t("Profile"),
      },
      {
        href: SUPPORT_URL_ORGANIZER,
        label: t("Support"),
      },
    ];

    const impersonationLink: LinksType = [
      {
        href: "/impersonate/stop/",
        label: "Stop Impersonate",
      },
    ];

    let loggedInLinks: LinksType = newLoggedInLinks;

    // if the user is being impersonated, concat link to end the impersonation
    if (user?.impersonator_id) {
      loggedInLinks = impersonationLink.concat(loggedInLinks);
    }

    return loggedInLinks;
  };

  const loggedOutLinks: LinksType = [
    {
      href: "/organizations/register/",
      label: t("Create An Event"),
    },
    {
      href: "/features",
      label: t("Why Showpass"),
      external: true,
    },
    {
      href: "/pricing",
      label: t("Pricing"),
      external: true,
    },
    {
      href: SUPPORT_URL_ORGANIZER,
      label: t("Support"),
    },
  ];

  return {
    getLoggedInNavBarLinks,
    loggedOutLinks,
  };
};

export default useNavigationRoutes;
